import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core';
import {
  setAdditionalItemFlg,
  searchAdditionalItemListPaging,
} from '../../actions/CompanyAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  DISP_COUNT_LIMIT,
  ADDITIONAL_ITEM_PAGING,
} from '../../../common/const';
import styles from './CompanyAdditionalItemListComponent.module.css';
import config from '../../../common/config';

class CompanyAdditionalItemListComponent extends Component {
  /**
  * ページ選択
  */
  changePage = async (page) => {
    const {
      searchAdditionalItemListPagingAct,
      additionalItemTarget,
      setSystemLodingFLgAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ページ番号を指定して検索処理実行
    await searchAdditionalItemListPagingAct(additionalItemTarget, page);
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      additionalItemFlg,
      additionalItemList,
      additionalItemPage,
    } = this.props;

    // ページングの表示処理 ここから
    let pagingArea = null;

    // 全体件数
    let totalCount = null;

    // 全体件数が最大取得件数以上の場合、全体件数を最大取得件数に設定
    if (additionalItemList
      && additionalItemList.all_count) {
      totalCount = additionalItemList.all_count < DISP_COUNT_LIMIT.ADDITIONAL_ITEM
        ? additionalItemList.all_count : DISP_COUNT_LIMIT.ADDITIONAL_ITEM;
    }

    // 全体件数が最大表示件数以下の場合、ページング表示処理を実施
    if (additionalItemList
      && totalCount) {
      const maxPageCount = totalCount === 0
        ? 1
        : Math.ceil(totalCount / ADDITIONAL_ITEM_PAGING.PAGE_RECORD_COUNT);

      // 最後のページ数を算出
      const endPageCount = additionalItemPage + ADDITIONAL_ITEM_PAGING.AFTER_PAGE_COUNT
        < maxPageCount ? additionalItemPage + ADDITIONAL_ITEM_PAGING.AFTER_PAGE_COUNT
        : maxPageCount;
      // 最初のページ数を算出
      const startPageCount = additionalItemPage - ADDITIONAL_ITEM_PAGING.BEFORE_PAGE_COUNT > 1
        ? additionalItemPage - ADDITIONAL_ITEM_PAGING.BEFORE_PAGE_COUNT
        : 1;

      const pageList = [];
      if (startPageCount > 1) {
        pageList.push(<span key={1} className="space">...</span>);
      }
      for (let count = startPageCount; count <= endPageCount; count += 1) {
        pageList.push(
          <span
            key={count}
            className={[
              endPageCount === count ? 'last-page-link' : 'page-link',
              additionalItemPage === count ? 'additionalItemPage' : '',
            ].join(' ')}
            onClick={additionalItemPage === count
              ? null
              : this.changePage.bind(this, count)}
          >
            {count}
          </span>,
        );
      }
      if (endPageCount < maxPageCount) {
        pageList.push(<span key={maxPageCount} className="space">...</span>);
      }
      pagingArea = (
        <Pagination
          variant="outlined"
          count={maxPageCount}
          onChange={(e, page) => this.changePage(page)}
          page={additionalItemPage}
          className={`${styles.summaryPage}`}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={
                item.page === additionalItemPage
                || (item.type === 'next' && additionalItemPage === maxPageCount)
                || (item.type === 'previous' && additionalItemPage === 1)
              }
              className={`${item.page === additionalItemPage ? styles.customPaginationItem : ''}`}
            />
          )}
        />
      );
    }

    // ページングの表示処理 ここまで

    // 表示件数作成
    const dispCountStart = (additionalItemPage - 1) * ADDITIONAL_ITEM_PAGING.PAGE_RECORD_COUNT + 1;
    const dispCountEnd = (additionalItemList
      && additionalItemList.result_count
      && totalCount)
      ? (additionalItemPage - 1) * ADDITIONAL_ITEM_PAGING.PAGE_RECORD_COUNT
      + Number(additionalItemList.result_count)
      : null;
    const dispResultCount = dispCountEnd ? `${dispCountStart}-${dispCountEnd}` : 0;

    // 全体件数
    const allCount = (additionalItemList && totalCount)
      ? Number(totalCount).toLocaleString()
      : 0;

    // 最大表示件数
    const dispCountLimit = Number(DISP_COUNT_LIMIT.ADDITIONAL_ITEM).toLocaleString();

    return (additionalItemFlg && (
      <>
        <div className={`${styles.infofield}`}>
          <div className={`${styles.resultcount}`}>
            <div>
              <span>検索結果：</span>
              <span className={`${styles.searchResult}`}>{dispResultCount}</span>
              {` / ${allCount}件`}
              <span className={`${styles.resultcountInfo}`}>
                ※最大
                {dispCountLimit}
                件までしか表示されません
              </span>
            </div>
            {pagingArea}
          </div>
        </div>
        <div className={config.TRADE_SEARCH_FLG.FLG1.DISP === '1'
          || config.TRADE_SEARCH_FLG.FLG2.DISP === '1'
          ? `${styles.listfield} ${styles.Serchflag}` : `${styles.listfield}`}
        >
          <Table className={`${styles.additionalTable}`}>
            <TableBody>
              {additionalItemList
                && additionalItemList.header_item_list
                && additionalItemList.header_item_list.map((headerItem, index) => (
                  <TableRow key={headerItem}>
                    <TableCell key={index.toString()} className={`${styles.listheader} ${styles.topheader}`}>
                      {headerItem}
                    </TableCell>
                    {additionalItemList
                      && additionalItemList.additional_item_lists
                      && additionalItemList.additional_item_lists
                        .map((additionalItemLists, level) => (
                          <TableCell className={`${styles.listitem}`} key={`${index.toString()}-${level.toString()}`}>
                            {additionalItemLists[index]}
                          </TableCell>
                        ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </>
    ));
  }
}

export default connect(
  (state) => ({
    additionalItemFlg: state.company.additionalItemFlg,
    additionalItemList: state.company.additionalItemList,
    additionalItemPage: state.company.additionalItemPage,
    additionalItemTarget: state.company.additionalItemTarget,
  }),
  (dispatch) => ({
    setAdditionalItemFlgAct: (bool) => dispatch(setAdditionalItemFlg(bool)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchAdditionalItemListPagingAct: (target,
      page) => dispatch(searchAdditionalItemListPaging(target, page)),
  }),

)(CompanyAdditionalItemListComponent);
